import React from 'react';
import './AboutKiosk.scss';
import { Icon } from '../../../components/ui/index';

const AboutKiosk = () => {
  return (
    <>
      <div id="frame-and-lenses-step" className="about-step active">
        <div className="step-section section1">
          <div className="wrapper">
            <div className="column left">
              <Icon imgPath="/images/about/about-scan-step3.png"></Icon>
            </div>
            <div className="column right">
              <h2>Scan your face at a VisionHub Kiosk</h2>
              <p>
                Live Measurement Frame service allows you to take your measurements quickly with or
                without assistance, as easily as for an ID photo. This service is the most important
                step of your purchasing experience.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="kiosk step-section section2">
        <div className="wrapper">
          <div className="column left">
            <h2>How does it works?</h2>
            <p>
              Based on a technology developed for VisionHub, all measurements are done with a simple
              picture. No need to know your chosen frame (s), the use of the reference frame gives
              all the data for making your new glasses.
            </p>
          </div>
          <div className="column right">
            <ul>
              <li>
                <Icon imgPath="/images/about/scan-face-step1.png"></Icon>
                <span className="label">Your distance</span>
              </li>
              <li>
                <Icon imgPath="/images/about/scan-face-step2.png"></Icon>
                <span className="label">Rotation of the screen</span>
              </li>
              <li>
                <Icon imgPath="/images/about/scan-face-step3.png"></Icon>
                <span className="label">Measurement frame</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default AboutKiosk;
